import { Button, Result } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { canAccess, type Capability } from '../config/access';
import { ForbiddenPage } from '../pages/ForbiddenPage';
import { useAuthStore } from '../store/auth';

export function RequireCap({ capability }: { capability: Capability }) {
  const navigate = useNavigate();
  const token = useAuthStore((state) => state.token);
  const profile = useAuthStore((state) => state.profile);
  const clear = useAuthStore((state) => state.clear);

  if (!token || !profile) {
    return (
      <Result
        status="warning"
        title="身份信息缺失，请重新登录"
        extra={
          <Button
            type="primary"
            onClick={() => {
              clear();
              navigate('/login', { replace: true });
            }}
          >
            重新登录
          </Button>
        }
      />
    );
  }

  // 前端守卫只改善导航体验，最终授权仍由后端接口决定。
  return canAccess(profile.roles, capability) ? <Outlet /> : <ForbiddenPage />;
}
